import { z } from "zod";

/**
 * AI Provider Schema
 * @package @genieartinc/schemas
 */

export const AiProviderSchema = z.object({
  id: z.string(),
  key: z.string(), // "fal", "genie"
  name: z.string(), // "Fal.ai", "Genie"
  enabled: z.boolean().default(true),
  apiBaseUrl: z.string().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type AiProvider = z.infer<typeof AiProviderSchema>;

// Create DTO
export const CreateAiProviderSchema = AiProviderSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export type CreateAiProvider = z.infer<typeof CreateAiProviderSchema>;

// Update DTO
export const UpdateAiProviderSchema = CreateAiProviderSchema.partial();

export type UpdateAiProvider = z.infer<typeof UpdateAiProviderSchema>;

// Provider keys (for type safety)
// Currently fal for inference, genie reserved for future self-hosted inference
export const AI_PROVIDER_KEYS = {
  FAL: "fal",
  GENIE: "genie",
} as const;

export type AiProviderKey = (typeof AI_PROVIDER_KEYS)[keyof typeof AI_PROVIDER_KEYS];
